const state = {
  visitedViews: JSON.parse(localStorage.getItem('merchant_visited_views') || '[]'),
  cachedViews: []
}

const mutations = {
  ADD_VISITED_VIEW(state, view) {
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push({
      name: view.name,
      path: view.path,
      title: view.meta.title || '未命名',
      icon: view.meta.icon || '',
      fullPath: view.fullPath || view.path
    })
    localStorage.setItem('merchant_visited_views', JSON.stringify(state.visitedViews))
  },

  DEL_VISITED_VIEW(state, view) {
    const index = state.visitedViews.findIndex(v => v.path === view.path)
    if (index > -1) {
      state.visitedViews.splice(index, 1)
      localStorage.setItem('merchant_visited_views', JSON.stringify(state.visitedViews))
    }
  },

  DEL_OTHERS_VISITED_VIEWS(state, view) {
    state.visitedViews = state.visitedViews.filter(v => {
      return v.meta && v.meta.affix || v.path === view.path
    })
    localStorage.setItem('merchant_visited_views', JSON.stringify(state.visitedViews))
  },

  DEL_ALL_VISITED_VIEWS(state) {
    state.visitedViews = []
    localStorage.setItem('merchant_visited_views', JSON.stringify(state.visitedViews))
  }
}

const actions = {
  addView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
  },
  delView({ commit }, view) {
    commit('DEL_VISITED_VIEW', view)
  },
  delOthersViews({ commit }, view) {
    commit('DEL_OTHERS_VISITED_VIEWS', view)
  },
  delAllViews({ commit }) {
    commit('DEL_ALL_VISITED_VIEWS')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}